import React, { useState, useEffect } from "react";

import Pagination from "../helpers/Pagination";

import { useTranslation } from "react-i18next";
import UserServices from "../../../../class/User_copy/UserService";

const CashHistory = ({ AuthService }) => {
  const userId = AuthService.getCustom("user_id");
  const currency = AuthService.getCustom("currency");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cashMovements, setCashMovements] = useState([]);
  const [resetEnabled, setResetEnabled] = useState(false);
  const [filter_by, setFilter_by] = useState("1 Month Ago");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [transactionType, setTransactionType] = useState("");

  const { t } = useTranslation();

  const loadCashMovements = async () => {
    setIsLoading(true);
    const limit = 10;
    try {
      const data = await UserServices.getCashMovement(
        userId,
        currency,
        transactionType,
        startDate,
        endDate,
        currentPage,
        limit,
      );

      if (data.status == "ok") {
        setCashMovements(data.params.transactions || []);
        setTotalPages(data.params.total_pages || 1);
      } else {
        setCashMovements([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching cash movements:", error);
      setCashMovements([]);
      setTotalPages(1);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadCashMovements();
  }, [currentPage, startDate, endDate, transactionType]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleReset = () => {
    setResetEnabled(false);
    setStartDate("");
    setEndDate("");
    setTransactionType("");
    setFilter_by("");
    setCurrentPage(1);
  };

  const handleCustomDateChange = (event) => {
    const { name, value } = event.target;
    const date = new Date(value); // Create a Date object from the input value
    setFilter_by("Custom");

    if (name === "start") {
      setStartDate(Math.floor(date.getTime() / 1000)); // Store the timestamp in seconds
    } else {
      setEndDate(Math.floor(date.getTime() / 1000)); // Store the timestamp in seconds
    }
  };

  const handleDateFilterChange = (event) => {
    const filter = event.target.value;
    const now = new Date();
    let start, end;

    if (filter === "1week") {
      start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      end = now;
      setFilter_by("1 Week Ago");
    } else if (filter === "2weeks") {
      start = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
      end = now;
      setFilter_by("2 Weeks Ago");
    } else if (filter === "1month") {
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
      setFilter_by("1 Month Ago");
    } else if (filter === "custom") {
      start = null; // Clear for custom
      end = null;
    }

    // Set hours to match the start and end of the day for timestamps
    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    // Set timestamps in seconds instead of milliseconds
    setStartDate(start ? Math.floor(start.getTime() / 1000) : null); // Convert to seconds
    setEndDate(end ? Math.floor(end.getTime() / 1000) : null); // Convert to seconds

    setResetEnabled(true);
    setCurrentPage(1);
  };

  const handleTransactionTypeChange = (type) => {
    switch (type) {
      case "all":
        setTransactionType("");
        break;
      case "deposit":
        setTransactionType("add");
        break;
      case "withdraw":
        setTransactionType("out");
        break;
      /* case 'bonus':
            setTransactionType('add_bonus');
            break; */
      default:
        setTransactionType("");
    }
    setResetEnabled(true);

    setCurrentPage(1);
  };

  return (
    <div className="form-online">
      <section className="forms boxed-form">
        <div className="form signup">
          <div className="form-content">
            <div className="header-form-content">
              <h3>
                <svg
                  viewBox="-2.5 0 19 19"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cf-icon-svg"
                >
                  <path d="M13.014 7.026v5.142a.476.476 0 0 1-.475.475H1.461a.476.476 0 0 1-.475-.475V7.026a.476.476 0 0 1 .475-.475h11.078a.476.476 0 0 1 .475.475zm-3.582 2.57a2.424 2.424 0 1 0-.191.947 2.417 2.417 0 0 0 .19-.946zm-.235-4.581a.554.554 0 0 1-.783 0l-.86-.86v1a.554.554 0 1 1-1.108 0v-1l-.86.86a.554.554 0 0 1-.783-.784l1.805-1.805a.554.554 0 0 1 .784 0L9.197 4.23a.554.554 0 0 1 0 .784zm0 9.947-1.805 1.806a.554.554 0 0 1-.784 0l-1.805-1.806a.554.554 0 0 1 .783-.783l.86.86v-1a.554.554 0 0 1 1.108 0v1l.86-.86a.554.554 0 1 1 .783.783zm-1.05-4.729a.83.83 0 0 1-.416.716 1.326 1.326 0 0 1-.413.173v.266a.317.317 0 0 1-.633 0v-.262a1.449 1.449 0 0 1-.268-.084.943.943 0 0 1-.362-.265.317.317 0 0 1 .479-.415.32.32 0 0 0 .118.092.842.842 0 0 0 .162.052 1.248 1.248 0 0 0 .176.022.765.765 0 0 0 .397-.11c.127-.082.127-.152.127-.185a.218.218 0 0 0-.053-.14.504.504 0 0 0-.132-.106.668.668 0 0 0-.163-.058.765.765 0 0 0-.16-.017 1.642 1.642 0 0 1-.273-.021 1.248 1.248 0 0 1-.352-.114 1.018 1.018 0 0 1-.335-.269.864.864 0 0 1-.198-.542.876.876 0 0 1 .435-.74 1.314 1.314 0 0 1 .402-.165v-.255a.317.317 0 0 1 .633 0v.264a1.513 1.513 0 0 1 .273.095 1.085 1.085 0 0 1 .318.218.317.317 0 0 1-.448.449.454.454 0 0 0-.13-.09.887.887 0 0 0-.167-.058l-.017-.004a.842.842 0 0 0-.137-.023.768.768 0 0 0-.389.104.249.249 0 0 0-.14.205.242.242 0 0 0 .057.143.394.394 0 0 0 .126.101.627.627 0 0 0 .173.056 1.01 1.01 0 0 0 .169.013 1.4 1.4 0 0 1 .295.03 1.305 1.305 0 0 1 .323.117 1.13 1.13 0 0 1 .314.25.848.848 0 0 1 .21.557z" />
                </svg>
                {t("deposit_and_withdrawals")}
              </h3>
              <div className="select_filter">
                {resetEnabled && (
                  <a className="reset-d-btn" onClick={handleReset}>
                    <svg
                      viewBox="0 0 1920 1920"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" />
                    </svg>
                  </a>
                )}

                <div className="drop_dash dropdown">
                  <a
                    className="dropdown-toggle no-arrow"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span id="selectedTitleDateSport">{filter_by}</span>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 45.402 45.402"
                      xmlSpace="preserve"
                    >
                      <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141                                  c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27                                  c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435                                  c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z" />
                    </svg>
                  </a>

                  <div
                    className="dropdown-menu dropdown-menu-end filter-section"
                    aria-labelledby="navbarDropdown"
                  >
                    <div className="radio-group">
                      <input
                        id="1weekSelectSport"
                        type="radio"
                        name="radio-group-sport"
                        className="radio-input"
                        autoComplete="off"
                        value="1week"
                        onChange={handleDateFilterChange}
                      />
                      <label htmlFor="1weekSelectSport" className="radio-label">
                        <span className="radio-inner-circle"></span>
                        {t("1_Week_Ago")}
                      </label>

                      <input
                        id="2weekSelectSport"
                        type="radio"
                        name="radio-group-sport"
                        className="radio-input"
                        autoComplete="off"
                        value="2weeks"
                        onChange={handleDateFilterChange}
                      />
                      <label htmlFor="2weekSelectSport" className="radio-label">
                        <span className="radio-inner-circle"></span>
                        {t("2_Week_Ago")}
                      </label>

                      <input
                        id="1monthSelectSport"
                        type="radio"
                        name="radio-group-sport"
                        className="radio-input"
                        autoComplete="off"
                        value="1month"
                        onChange={handleDateFilterChange}
                      />
                      <label
                        htmlFor="1monthSelectSport"
                        className="radio-label"
                      >
                        <span className="radio-inner-circle"></span>
                        {t("1_Month_Ago")}
                      </label>
                    </div>

                    {true && (
                      <div className="input-group input-daterange">
                        <input
                          type="date"
                          name="start"
                          className="form-control date_start_sport"
                          onChange={handleCustomDateChange}
                        />
                        <div className="input-group-text">to</div>
                        <input
                          type="date"
                          name="end"
                          className="form-control date_end_sport"
                          onChange={handleCustomDateChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="radio2">
              <input
                type="radio"
                label={t("All")}
                name="data_type_change2"
                value="all"
                onChange={() => handleTransactionTypeChange("all")}
                defaultChecked
              />
              <input
                label={t("Deposit")}
                type="radio"
                name="data_type_change2"
                onChange={() => handleTransactionTypeChange("deposit")}
              />
              <input
                label={t("Whidtdraw")}
                type="radio"
                name="data_type_change2"
                onChange={() => handleTransactionTypeChange("withdraw")}
              />
              {/* <input label={t('Bonus')} type="radio" name="data_type_change2" onChange={() => handleTransactionTypeChange('bonus')} /> */}
            </div>

            <div className="responsive-table__upper-element right-shadow history">
              <div className="responsive-table__left-shadow-el"></div>
              <div className="responsive-table__wrapper">
                <div className="responsive-table">
                  <div className="responsive-table__cell responsive-table__header sticky-header-and-first-col">
                    {t("Date")}
                  </div>
                  <div className="responsive-table__cell responsive-table__header">
                    {t("Operations")}
                  </div>
                  <div className="responsive-table__cell responsive-table__header">
                    {t("Balance")}
                  </div>
                  <div className="responsive-table__cell responsive-table__header">
                    {t("ID")}
                  </div>
                  <div className="responsive-table__cell responsive-table__header responsive-table__cell--last-of-row">
                    {t("Status")}
                  </div>

                  {isLoading ? (
                    <div className="content-loader-games">
                      {t("loading")}...
                    </div>
                  ) : (
                    cashMovements.map((movement) => (
                      <React.Fragment key={movement.id}>
                        <div className="responsive-table__cell sticky-cell">
                          {new Date(movement.addedTime * 1000).toLocaleString()}
                        </div>
                        <div className="responsive-table__cell">
                          {movement.type === "add" ? (
                            <>
                              {t("Deposit")}
                              <br />
                            </>
                          ) : movement.type === "out" ? (
                            <>
                              {t("Withdraw")}
                              <br />
                            </>
                          ) : movement.type === "add_bonus" ? (
                            <>
                              {t("Bonux")}
                              <br />
                            </>
                          ) : (
                            <>
                              {t("Unknown")}
                              <br />
                            </>
                          )}
                          <span
                            className={`transaction_${movement.type === "add" ? "deposit" : movement.type === "out" ? "widthdraw" : movement.type === "add_bonus" ? "bonus" : ""}`}
                          >
                            <strong>{movement.amount}</strong>
                          </span>
                        </div>
                        <div className="responsive-table__cell">
                          {movement.ref_new_balance}
                        </div>
                        <div className="responsive-table__cell">
                          {movement.id}
                        </div>
                        <div className="responsive-table__cell responsive-table__cell--last-of-row">
                          {/* Common tooltip structure for all statuses */}
                          {movement.request_status === undefined ? (
                            <div
                              className="ok_dw"
                              data-toggle="tooltip"
                              data-bs-html="true"
                              aria-label={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              data-bs-original-title={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              aria-describedby={`tooltip-${movement.id}`}
                            ></div>
                          ) : movement.request_status === 0 ? (
                            <div
                              className="pending"
                              data-toggle="tooltip"
                              data-bs-html="true"
                              aria-label={`pending:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              data-bs-original-title={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              aria-describedby={`tooltip-${movement.id}`}
                            ></div>
                          ) : movement.request_status === 1 ? (
                            <div
                              className="cancelled"
                              data-toggle="tooltip"
                              data-bs-html="true"
                              aria-label={`cancelled:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              data-bs-original-title={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              aria-describedby={`tooltip-${movement.id}`}
                            ></div>
                          ) : (
                            <div
                              className="ok_dw"
                              data-toggle="tooltip"
                              data-bs-html="true"
                              aria-label={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              data-bs-original-title={`Approvato:<br>${new Date(movement.addedTime * 1000).toLocaleString()}`}
                              aria-describedby={`tooltip-${movement.id}`}
                            ></div>
                          )}
                        </div>
                      </React.Fragment>
                    ))
                  )}
                </div>

                {cashMovements.length === 0 && !isLoading && (
                  <div className="no-content-search">
                    <p>{t("No_results_found_for_your_query.")}</p>
                  </div>
                )}
              </div>
            </div>

            <div className="pagination_list_element">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <a
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                  />
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <a
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">»</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CashHistory;
